import React, { createContext, useContext, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
const LocationContext = createContext();

export const useLocationContext = () => {
  return useContext(LocationContext);
};

export const LocationProvider = ({ children }) => {
  const [locationData, setLocationData] = useState({});

  return (
    <LocationContext.Provider value={{ locationData }}>
      {children}
    </LocationContext.Provider>
  );
};
